/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/CheckoutHeader/theme';

export const CheckoutHeaderTheme = theme;
